import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'lookUpOptions',
      'permission'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/public/mixins/computed.js